
import theme from "../../../styles/theme";
import React, { useState } from "react";

const TabsNavHorizontal = ({ labels, activeIndex, onChange }) => {
  const [hovered, setHovered] = useState(null);

  const bgHover    = theme.colors.background.hover;
  const textActive = theme.colors.text.primary; 
  const textIdle   = theme.colors.text.third;
  const gap        = theme.spacing.md;                   // espacement entre icône et label
  const padY       = theme.spacing.sm;
  const padX       = theme.spacing.lg;
  const radius     = theme.borders.radius.md;
  const fwMedium   = theme.fontWeights.normal;
  const fwSelected = theme.fontWeights.selected;         // poids pour onglet actif
  const font       = theme.fonts.primary;
  const bgSelected = theme.colors.background.selected    // background pour onblet actif
  


  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",       // Horizontal
        gap,
        justifyContent: "center",
        alignItems: "center",
        padding: padY,              // padding global vertical du conteneur
      }}
    >
      {labels.map((tab, index) => {
        const data = typeof tab === "string" ? { label: tab } : tab;
        const isActive = index === activeIndex;
        const isHover  = hovered === index;

        return (
          <div
            key={index}
            onClick={() => onChange(index)}         // sélection de l'onglet
            onMouseEnter={() => setHovered(index)}  // survol
            onMouseLeave={() => setHovered(null)} // fin du survol
            style={{
              cursor: "pointer",
              padding: `${padY}px ${padX}px`,
              borderRadius: radius,
              backgroundColor: isActive ? bgSelected : isHover ? bgHover : "transparent",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap,
              transition: "background-color 0.2s ease, color 0.2s ease, transform 0.2s ease",
              userSelect: "none",
              borderRadius: radius,
            }}
          >
            {/* Icône éventuelle */}
            {data.icon && (
              <img
                src={data.icon}
                alt={`${data.label}-icon`}
                style={{
                  width: 20,
                  height: 20,
                  filter: "none",
                  transform: isHover ? "scale(1.15)" : "scale(1)",
                  transition: "transform 0.2s ease",
                }}
              />
            )}
            {/* Label de l'onglet */}
            <span
              style={{
                fontFamily: font,
                fontWeight: isActive ? fwSelected : fwMedium,
                color: isActive ? textActive : isHover ? textActive : textIdle,
                whiteSpace: "nowrap",
              }}
            >
              {data.label}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default TabsNavHorizontal;
